import React, { useEffect, useState ,useRef} from "react";
import axios from "axios";
import Header from './Header'
import Footer from './Footer'


const QuickQuoteForm = () => {
  const [services, setServices] = useState([]);
  const [status, setStatus] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    organization: "",
    service: "",
    message: "",
  });

  useEffect(() => {
  axios
    .get("https://dhk.deliveryxpressbd.com/Services/all_services_api")
    .then((res) => {
      setServices(res.data || []);
    })
    .catch((err) => {
      console.error("API Error:", err);
    });
}, []);







  const handleChange = (e) => {
    const { name, value } = e.target;

    // Restrict phone input to numbers only
    if (name === "phone" && !/^\d*$/.test(value)) return;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    const formBody = new URLSearchParams(formData).toString();

    try {
      const response = await fetch("https://dhk.deliveryxpressbd.com/Services/send_quote_api", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      });

      if (response.ok) {
        setStatus("Your request has been sent!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          organization: "",
          service: "",
          message: "",
        });
      } else {
        setStatus("Failed to send message.");
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("Something went wrong.");
    }
  };


 

  return (

    <>
    <Header />
    <section className="about_section layout_padding bg-light">
      <div className="container">
        <div className="card shadow">
          <div className="card-body">
            <h1 className="card-title text-center mb-4">Get a Quick Quote</h1>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label htmlFor="name" className="formttl">Name :</label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                  />
                </div>

                <div className="form-group col-md-6">
                  <label htmlFor="phone" className="formttl">Phone :</label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Your Phone Number"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-6">
                  <label htmlFor="email" className="formttl" >Email :</label>
                  <input
                    required
                    type="email"
                    className="form-control" data-ignore="true"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                  />
                </div>

                <div className="form-group col-md-6">
                  <label htmlFor="organization" className="formttl">Organization Name :</label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    id="organization"
                    name="organization"
                    value={formData.organization}
                    onChange={handleChange}
                    placeholder="Your Organization"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="service" className="formttl">Select Service :</label>
                <select
                    required
                    className="form-control"
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">-- Choose a Service --</option>
                    {Array.isArray(services) && services.length > 0 ? (
                      services.map((service) => (
                        <option key={service.name} value={service.name}>
                          {service.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>Loading services...</option>
                    )}
                  </select>
              </div>

              <div className="form-group">
                <label htmlFor="message" className="formttl">Message (optional) :</label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your message..."
                ></textarea>
              </div>

              <button type="submit" className="btn btn-success btn-block">
                Submit For Quote
              </button>

              {status && <p className="mt-3 text-info">{status}</p>}
            </form>
          </div>
        </div>
      </div>
    </section>
    <Footer />
    </>
  );
};

export default QuickQuoteForm;
